import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import hello from '../../assets/hello.png';
import './Main.css';

toast.configure();

const Main = () => {
  const [extraData, setExtraData] = useState([]);
  const [ownerName, setOwnerName] = useState('');

  useEffect(() => {
    loadUser();
  }, []);

  const loadUser = async () => {
    const username = JSON.parse(localStorage.getItem('uname'));
    const URL = `https://stucharge.bakersbrisk.com/api/getapp?username=${username}`;
    const AuthStr = process.env.REACT_APP_AUTH_STR;
    const result = await axios.get(URL, {
      headers: { Authorization: AuthStr },
    });
    if (result.status === 200) {
      setExtraData(result.data.extra_details);
      setOwnerName(result.data.user_details.owner_name);
      localStorage.setItem(
        'app_icon',
        JSON.stringify(result.data.user_details.app_icon)
      );
    } else {
      toast.error('Something went wrong, please refresh');
    }
  };

  return (
    <main>
      <div className='main_container'>
        <div className='main_title'>
          <img src={hello} alt='hello' width='50' />
          <div className='main_greeting'>
            <h1>Hello {ownerName}</h1>
            <p>Welcome to your Admin Dashboard</p>
          </div>
        </div>

        <div className='main_cards'>
          <div className='card'>
            <i className='fas fa-user-alt fa-2x text-lightblue'></i>
            <div className='card_inner'>
              <p className='text-primary-p'>Total Students</p>
              <span className='font-bold text-title'>
                {extraData.total_students}
              </span>
            </div>
          </div>

          <div className='card'>
            <i className='fas fa-book-reader fa-2x text-yellow'></i>
            <div className='card_inner'>
              <p className='text-primary-p'>Total Courses</p>
              <span className='font-bold text-title'>
                {extraData.total_courses}
              </span>
            </div>
          </div>

          <div className='card'>
            <i className='fas fa-video fa-2x text-red'></i>
            <div className='card_inner'>
              <p className='text-primary-p'>Total Lectures</p>
              <span className='font-bold text-title'>
                {extraData.total_lectures}
              </span>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Main;
